/* =========================================================
   FP Header Points button — simple open-only version
   - No points scraping
   - No cache
   - No hidden Rivo Account Dashboard dependency
   - Clicks the real Rivo launcher so the iframe loads properly
   ========================================================= */

(function () {
  'use strict';

  if (window.__fpHeaderPointsOpenOnlyLoaded) return;
  window.__fpHeaderPointsOpenOnlyLoaded = true;

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function positionRivoWidget() {
    // Mobile should use Rivo's own full-screen widget behaviour, as on the live site.
    if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) return;

    var trigger = qs('[data-fp-header-points-trigger]');
    var wrapper = qs('#loy-widget-wrapper');

    if (!trigger || !wrapper) return;

    var rect = trigger.getBoundingClientRect();
    var top = Math.max(8, Math.round(rect.bottom + 8));
    var right = Math.max(12, Math.round(window.innerWidth - rect.right));

    wrapper.style.setProperty('position', 'fixed', 'important');
    wrapper.style.setProperty('top', top + 'px', 'important');
    wrapper.style.setProperty('right', right + 'px', 'important');
    wrapper.style.setProperty('left', 'auto', 'important');
    wrapper.style.setProperty('bottom', 'auto', 'important');
    wrapper.style.setProperty('z-index', '2147483647', 'important');
  }

  function firePointerDown(element) {
    if (!element) return;

    try {
      element.dispatchEvent(new PointerEvent('pointerdown', {
        bubbles: true,
        cancelable: true,
        pointerType: 'mouse'
      }));
    } catch (error) {
      try {
        element.dispatchEvent(new MouseEvent('mousedown', {
          bubbles: true,
          cancelable: true
        }));
      } catch (error2) {}
    }
  }

  function openRivoWidget() {
    var launcher = qs('#launcher-wrapper.ba-loy-circle') || qs('#launcher-wrapper');
    var handler = qs('#launcher-wrapper .ba-met-handler');

    // Critical: position the existing Rivo wrapper BEFORE opening.
    // This avoids the brief left-side flash before our later reposition runs.
    positionRivoWidget();

    // Proven working flow from the old theme / console test.
    // Do not create an iframe and do not set iframe src manually.
    firePointerDown(launcher);

    if (handler && typeof handler.click === 'function') {
      handler.click();

      // Keep it pinned while Rivo finishes opening/loading.
      window.requestAnimationFrame(positionRivoWidget);
      window.setTimeout(positionRivoWidget, 60);
      window.setTimeout(positionRivoWidget, 250);
      window.setTimeout(positionRivoWidget, 800);
      return true;
    }

    return false;
  }

  function bindHeaderButton() {
    var trigger = qs('[data-fp-header-points-trigger]');
    if (!trigger || trigger.__fpHeaderPointsOpenBound) return;

    trigger.__fpHeaderPointsOpenBound = true;
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');

    trigger.addEventListener('pointerdown', function () {
      // Pre-position as early as possible, before click opens the widget.
      positionRivoWidget();
    }, { passive: true });

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openRivoWidget();
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        event.stopPropagation();
        openRivoWidget();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHeaderButton);
  } else {
    bindHeaderButton();
  }

  window.addEventListener('resize', positionRivoWidget);
  window.addEventListener('scroll', positionRivoWidget, { passive: true });
})();
